import { graphqlApiClient } from '../client';
import { PRODUCT_PAGE_QUERY, ProductPageQueryResponse, ProductPageQueryVariants } from './query';
import { PageInfo } from './types';

export async function fetchGraphqlProductPage(
  pageHandle: string,
  variantImages: Record<string, string>
) {
  try {
    const handles = pageHandle.split('|');

    const results = await Promise.all(
      handles.map(async (handle): Promise<PageInfo | null> => {
        const result = await graphqlApiClient<ProductPageQueryResponse, ProductPageQueryVariants>(
          PRODUCT_PAGE_QUERY,
          { handle }
        );

        const page = result.page;
        if (!page) return null;

        return {
          body: addTargetBlank(page.body),
          title: page.title,
          image: variantImages[handle] || '',
        };
      })
    );

    return results.filter((v): v is PageInfo => v !== null);
  } catch (error) {
    console.error(error);
    return null;
  }
}

const addTargetBlank = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelectorAll('a').forEach((a) => {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  });

  return doc.body.innerHTML;
};
